import { z } from 'zod';
import type { OtherWikiPartsFragment } from '~/apollo/generated/v4/graphql';

export const otherWikiSchema = z.object({
  title: z.string().min(1),
  text: z.string().min(1),
});

export type OtherWikiFormValues = {
  title: string;
  text: string;
};

export function initialOtherWiki(
  ow?: OtherWikiPartsFragment,
): OtherWikiFormValues {
  return {
    title: ow?.title ?? '',
    text: ow?.text ?? '',
  };
}
